import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux';
import { Grid } from '@mui/material';

import MfdigitalstatusDashboard from '../MfdigitalstatusDashboard';

import { openDrawer } from './../../../store/slice/MenuSlice';

export default function MfdigitalstatusPage() {
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(openDrawer(false));
    },[]);

    return (
        < MfdigitalstatusDashboard />
    )

}